<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter0">Contents</h1>
<p class="toc"><a class="hlink" href="#/OEBPS/9781446350935_epub_int_r1.htm">Introduction</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9781446350935_epub_fm_r1.htm">Getting Started</a></p>
<p class="toc1"><img alt="" src="OEBPS/images/6-1.jpg"/><a class="hlink" href="#/OEBPS/9781446350935_epub_c01_r1.htm"> Hidden in the Stars</a></p>
<p class="toc1"><img alt="" src="OEBPS/images/6-4.jpg"/><a class="hlink" href="#/OEBPS/9781446350935_epub_c02_r1.htm"> Pick and Mix</a></p>
<p class="toc1"><img alt="" src="OEBPS/images/6-7.jpg"/><a class="hlink" href="#/OEBPS/9781446350935_epub_c03_r1.htm"> Vertical Drop</a></p>
<p class="toc1"><img alt="" src="OEBPS/images/6-10.jpg"/><a class="hlink" href="#/OEBPS/9781446350935_epub_c04_r1.htm"> May Flowers</a></p>
<p class="toc1"><img alt="" src="OEBPS/images/6-2.jpg"/><a class="hlink" href="#/OEBPS/9781446350935_epub_c05_r1.htm"> Peace Medallion</a></p>
<p class="toc1"><img alt="" src="OEBPS/images/6-5.jpg"/><a class="hlink" href="#/OEBPS/9781446350935_epub_c06_r1.htm"> Beach Hut Parade</a></p>
<p class="toc1"><img alt="" src="OEBPS/images/6-8.jpg"/><a class="hlink" href="#/OEBPS/9781446350935_epub_c07_r1.htm"> Birthday Gift</a></p>
<p class="toc1"><img alt="" src="OEBPS/images/6-11.jpg"/><a class="hlink" href="#/OEBPS/9781446350935_epub_c08_r1.htm"> Knickerbocker Glory</a></p>
<p class="toc1"><img alt="" src="OEBPS/images/6-3.jpg"/><a class="hlink" href="#/OEBPS/9781446350935_epub_c09_r1.htm"> Candy Heart</a></p>
<p class="toc1"><img alt="" src="OEBPS/images/6-6.jpg"/><a class="hlink" href="#/OEBPS/9781446350935_epub_c10_r1.htm"> Zen and the Jelly Roll</a></p>
<p class="toc1"><img alt="" src="OEBPS/images/6-9.jpg"/><a class="hlink" href="#/OEBPS/9781446350935_epub_c11_r1.htm"> Jelly Roll Bargello</a></p>
<p class="toc1"><img alt="" src="OEBPS/images/6-12.jpg"/><a class="hlink" href="#/OEBPS/9781446350935_epub_c12_r1.htm"> Be My Valentine</a></p>
<p class="toc1"><img alt="" src="OEBPS/images/6-13.jpg"/><a class="hlink" href="#/OEBPS/9781446350935_epub_c13_r1.htm"> Valentine Cushion</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9781446350935_epub_c14_r1.htm">General Techniques</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9781446350935_epub_ack_r1.htm">Acknowledgments</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9781446350935_epub_ata_r1.htm">About the Authors</a></p>
<p class="toc"><a class="hlink" href="#/OEBPS/9781446350935_epub_usc_r1.htm">Useful Contacts</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781446350935_epub_toc_r1.vue?5edf5a55